// extracted by css-extract-rspack-plugin
export default {"iconSlot":"E8TVg","iconWrapper":"H9hk9","pinned":"e14ZU","disabled":"hxBVs"};